

//Función para validar si el día es fin de semana o es un día antes del actual
export const esDiaValido = (fecha) => {
  const hoy = new Date();
  hoy.setHours(0, 0, 0, 0);


  const diaSemana = fecha.getDay(); // 0 = domingo, 6 = sábado
  if (diaSemana === 0 || diaSemana === 6) {
    return false;
  }
  if (fecha <= hoy) {
    return false;
  }
  return true;
};

//Función para Validar que esten todos los campos llenos en una nueva reservación
export const validarCamposFormData = (formData) => {
  const {
    nombrePrv,
    correoPrv,
    telefonoPrv,
    compania,
    fechaRsv,
    almacen_id,
    numeroOC,
    nmInsumo,
    cantidad,
    numeroCntdr,
    pesoOcantidad,
    numeroPallets,
    undmdas_id,
    containers_id,
    conditions_id,
    statuses_id,
    folio
  } = formData;

  if (!nombrePrv ||
    !correoPrv ||
    !telefonoPrv ||
    !compania ||
    !fechaRsv ||
    !almacen_id ||
    !numeroOC ||
    !nmInsumo ||
    !cantidad ||
    !numeroCntdr ||
    !pesoOcantidad ||
    !numeroPallets ||
    !undmdas_id ||
    !containers_id ||
    !conditions_id ||
    !statuses_id ||
    !folio) {
    return false;
  }
  return true;
};

//Función que devuelve una fecha sin las horas
export const formatearFecha = (fechaISO) => {
  const fecha = new Date(fechaISO);
  const year = fecha.getUTCFullYear();
  const month = fecha.getUTCMonth() + 1; // Los meses en JavaScript van de 0 a 11, así que sumamos 1
  const day = fecha.getUTCDate(); // Obtiene el día en UTC

  // Retorna la fecha formateada en formato dd/mm/aaaa
  return `${day.toString().padStart(2, '0')}/${month.toString().padStart(2, '0')}/${year}`;
};

export const obtenerDescripcion = (id, lista) => {
  const item = lista.find((elem) => elem.id == id);
  return item ? (item.descripcion || item.ubicacion) : 'No disponible';
};

export const obtenerEmpresa = (id, lista) => {
  const item = lista.find((elem) => elem.id === id);
  return item ? item.Empresa : 'No disponible';
};

export const formatearFechaPlano = (fecha) => {
  if (!fecha) return 'No disponible';
  const fechaSolo = fecha.split('T')[0];
  const [year, month, day] = fechaSolo.split('-');
  return `${day}/${month}/${year}`;
};

export const validarCamposTransportista = (formData) => {
  const {
    nameOpr,
    telefonoOpr,
    vehiculo_id,
    placa,
    numOprUdad,
    personalAdcnl,
    correoTrp
  } = formData

  if (!nameOpr ||
    !telefonoOpr ||
    !vehiculo_id ||
    !placa ||
    !numOprUdad ||
    !personalAdcnl ||
    !correoTrp) {
    return false;
  }
  return true;

}

export const calcularHoraFin = (horaInicio, duracion) => {
  const [hours, minutes] = horaInicio.split(':').map(Number);
  const date = new Date(0, 0, 0, hours, minutes);
  date.setMinutes(date.getMinutes() + duracion);
  return date.toTimeString().split(' ')[0].substring(0, 5); // Retornamos solo las horas y minutos
};

export const combinarFechaYHora = (fecha, hora) => {
  const fechaBase = fecha.toISOString().split('T')[0];  // Extrae solo la parte de la fecha
  return `${fechaBase} ${hora}:00`;
};
export const construirFechaSinHoraExtra = (fecha) => {
  if (fecha) {
    return fecha.toISOString().split('T')[0]; // Retorna solo la fecha en formato YYYY-MM-DD
  } else {
    return '';
  }
};

//Devuelve las horas planas en formato ISO a horas en formato HH:MM
export const formatearHora = (horaISO) => {
  const fecha = new Date(horaISO);
  // Extraer la hora y minuto en el formato de 24 horas
  const horas = fecha.getUTCHours().toString().padStart(2, '0');
  const minutos = fecha.getUTCMinutes().toString().padStart(2, '0');
  return `${horas}:${minutos}`;
};

//Devuelve las horas en formato HH:MM en minutos
export const horasAMinutos = (hora) => {
  const [horas, minutos] = hora.split(':').map(Number);
  const totalMinutos = horas * 60 + minutos;

  return totalMinutos;
}

//Función que devuelve la duración en formato de minutos, requiere las horas en formato HH:MM
export const calcularDuracionEnMinutos = (horaInicio, horaFin) => {

  const [horasInicio, minutosInicio] = horaInicio.split(':').map(Number);
  const [horasFin, minutosFin] = horaFin.split(':').map(Number);

  const minutosInicioTotales = horasInicio * 60 + minutosInicio;
  const minutosFinTotales = horasFin * 60 + minutosFin;


  const duracionEnMinutos = minutosFinTotales - minutosInicioTotales;

  return duracionEnMinutos + ' minutos';
};

const recipients = [
  { email: 'christian.castillo@grimann.com.mx', empresa_id: 1 },
  { email: 'diego.morales@grimann.com.mx', empresa_id: 1 },
  { email: 'alejandro.escutia@grimann.com.mx', empresa_id: 1 },
  { email: 'ernesto.cervantes@grimann.com.mx', empresa_id: 1 },
  { email: 'carlos.garciat@grimann.com.mx', empresa_id: 1 },
  { email: 'katia.gonzalez@grimann.com.mx', empresa_id: 1 },
  { email: 'almacen.ext2@grimann.com.mx', empresa_id: 1 },
  { email: 'saul.mauro@grimann.com.mx', empresa_id: 1 },
  { email: 'jesus.delrio@grimann.com.mx', empresa_id: 1 },
  { email: 'iver.cortez@grimann.com.mx', empresa_id: 1 },
  { email: 'amiranda@grimann.com.mx', empresa_id: 1 },
  { email: 'ruben.laureles@grimann.com.mx', empresa_id: 1 },
  { email: 'christian.rivero@sanfer.com.mx', empresa_id: 1 },
  { email: 'guillermo.colin@grimann.com.mx', empresa_id: 1 },
  { email: 'almacencefalosporinas@grimann.com.mx', empresa_id: 1 },

  { email: 'bjuarez@mavifarmaceutica.com', empresa_id: 2 },
  { email: 'chromero@mavifarmaceutica.com', empresa_id: 2 },
  { email: 'mrhernandez@mavifarmaceutica.com', empresa_id: 2 },
  { email: 'bibarra@mavifarmaceutica.com', empresa_id: 2 },
  { email: 'maria.munoz@mavifarmaceutica.com', empresa_id: 2 },
  { email: 'ricardo.vazquez@mavifarmaceutica.com', empresa_id: 2 },
  { email: 'aaron.cervantes@mavifarmaceutica.com', empresa_id: 2 },
  { email: 'diana.gachuz@mavifarmaceutica.com', empresa_id: 2 },
  { email: 'andres.cruz@mavifarmaceutica.com', empresa_id: 2 },

  { email: 'rcastro@grupoidisa.com', empresa_id: 3 },
  { email: 'carlos.rodriguezp@sanfersaludanimal.com', empresa_id: 3 },
  { email: 'carlos.garciah@grimann.com.mx', empresa_id: 3 },

  { email: 'almacen@probiomed.com.mx', empresa_id: 4 },
  { email: 'tiana.toledo@probiomed.com.mx', empresa_id: 4 },
  { email: 'maria.perezc@probiomed.com.mx', empresa_id: 4 },
  { email: 'ivan.quijano@probiomed.com.mx', empresa_id: 4 },
  { email: 'jose.sepulveda@probiomed.com.mx', empresa_id: 4 },
  { email: 'manuel.villanueva@probiomed.com.mx', empresa_id: 4 },
  { email: 'jose.rodriguezb@probiomed.com.mx', empresa_id: 4 },
  { email: 'tadeo.flores@probiomed.com.mx', empresa_id: 4 },
];

/*const recipients = [
  { email: 'andre.ricoy@sanfer.com.mx', empresa_id: 4},
]; */

export const obtenerCorreosPorEmpresa = (empresa_id, almacen_nombre = null) => {
  // Excepción: si el almacén es MAVI FARMACEUTICA, enviar a la lista de MAVI (empresa 2)
  let empresaFiltro = empresa_id;
  if (almacen_nombre && almacen_nombre.toLowerCase().includes('mavi farmaceutica')) {
    empresaFiltro = 2;
  }
  return recipients
    .filter(rec => rec.empresa_id === empresaFiltro)
    .map(rec => rec.email);
}




export const urlApi = process.env.REACT_APP_API_URL || 'http://localhost:5001';